import React, { useState, useReducer, useEffect } from "react"
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  CircularProgress,
  Alert
} from "@mui/material"
import { Modal } from "antd"

import FilePondUpload from "components/Common/FilePondUpload"
import { getCurrentUser, enumToArray } from "helpers/service_helper"
import { FileGasProjectType } from "models/types/file-gas-project-type"
import GridSupportFilesAnt from "components/Common/GridSupportFilesAnt"

export const SupportFiles = ({ rowData, mainProps, setErrorMessage }) => {
  const { lstSupportFiles } = mainProps
  const style = {
    // border: "2px solid #000",
    p: 2,
  }
  const [files, setFiles] = useState([])
  const [formInput, setFormInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      supportId: rowData.id,
      fileTypeEnum: 30
    }
  )
  const [open, setOpen] = useState(false)
  const [fileGasProjectTypes, setFileGasProjectTypes] = useState([])
  useEffect(() => {
    setFileGasProjectTypes(enumToArray(FileGasProjectType))
  }, [])

  const handleInput = evt => {
    const name = evt.target.name
    const newValue = evt.target.value
    console.log(name, newValue)
    setFormInput({ [name]: newValue })
  }
  const saveToDatabase = async (values) => {
    const { onAddSupportFile } = mainProps
      let file = files[0].file
     const fileName = FileGasProjectType[30]
      let formData = new FormData()
      formData.append("file", file, fileName + "." + file.name.split('.')[file.name.split('.').length-1])
      formData.append("supportId", JSON.stringify(values.supportId))
      formData.append("name","support-" + fileName)
      formData.append("des", `Upload with-${getCurrentUser().sid}`)
      formData.append("fileTypeEnum",fileName)
      formData.append("FolderName", "Supports")
      formData.append("FileName", fileName + "." + file.name.split('.')[file.name.split('.').length-1])
      formData.append("userId", getCurrentUser().sid)
      formData.append("toUserId", getCurrentUser().sid)
     await onAddSupportFile(formData)
  }
  const handleSubmitForm = async (event, values) => {
    event.preventDefault()

    if (formInput.supportId.length !== 0 && files[0]) {
    await saveToDatabase(formInput)
    // await onGetSupportFiles(formInput.supportId)
    }else {
      setErrorMessage("برای ذخیره ابتدا فایل را برگذاری کنید")
    }
  }
  return (
    <Box>
      <Button
        variant="contained"
        color="primary"
        size="small"
        style={{}}
        onClick={async () => {
          const { onGetSupportFiles } = mainProps

          await onGetSupportFiles(rowData.id)

          setOpen(!open)
        }}
      >
        فایلها
      </Button>

      <Modal
        open={open}
        title={"مدیریت فایل ها:" + rowData.fileNumber}
        onCancel={() => setOpen(false)}
        onClose={() => {
          setOpen(false)
        }}
        footer={null}
      >
        <form onSubmit={handleSubmitForm}>
          <DialogTitle>
             پیوست  پرونده: {rowData.fileNumber}
          </DialogTitle>
          <DialogContent>
            <Grid item xs={12}>
                {mainProps.error ? (
                  <Alert severity="error">{mainProps.error}</Alert>
                ) : null}
                {mainProps.success ? (
                  <Alert severity="success">{mainProps.success}</Alert>
                ) : null}
              </Grid>
            <Box sx={{ ...style }}>
              <GridSupportFilesAnt lstSupportFiles={lstSupportFiles} props={mainProps} />
            </Box>
            <Box>
              <Grid container spacing={1}>

                
                <Grid item xs={12}>
                <FilePondUpload
                  setFiles={setFiles}
                  maxFileSize="3000KB"
                  allowMultiple={false}
                  maxFiles={1}
                  acceptedFileTypes={["image/png", "image/jpeg"]}
                  imagePreviewMaxHeight={600}
                  labelText="فایل مربوطه را اینجا بکشید"
                  waterMark={false}
                />
              </Grid>
                
              </Grid>
            </Box>
          </DialogContent>

          <DialogActions>
            <Box sx={{ display: "flex" }}>
              {mainProps.loading ? (
                <CircularProgress disableShrink />
              ) : (
                <Button  variant="contained" type="submit">
                  ذخیره
                </Button>
              )}
            </Box>
          </DialogActions>
        </form>
      </Modal>
    </Box>
  )
}
